module.exports = __webpack_public_path__ + "static/media/375.beaaf8a8.jpg";